import {
  activityColumnDefinition,
  countryTaxTypeColumnDefinition,
  directionColumnDefinition,
  g2sColumnDefinition,
  gaapColumnDefinition,
  glAccount2ndPriorColumnDefinition,
  glAccountCurrentColumnDefinition,
  glAccountPriorColumnDefinition,
  lineColumnDefinition,
  slAccountColumnDefinition,
  typeColumnDefinition,
  debitUsdColumnDefinition,
  creditUsdColumnDefinition,
} from '../columnDefinitions';

export default [
  countryTaxTypeColumnDefinition,
  typeColumnDefinition,
  activityColumnDefinition,
  { ...slAccountColumnDefinition, headerName: 'SL Account' },
  gaapColumnDefinition,
  g2sColumnDefinition,
  lineColumnDefinition,
  directionColumnDefinition,
  glAccountCurrentColumnDefinition,
  glAccountPriorColumnDefinition,
  glAccount2ndPriorColumnDefinition,
  debitUsdColumnDefinition,
  creditUsdColumnDefinition,
];
